/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import msOffice from "../assets/img/office.png";
import vsCode from "../assets/img/vscpde.png";
// import xampp from "../assets/img/xamppp.png";
// import phpMyAdmin from "../assets/img/phpmyadmon.png";
import html from "../assets/img/html1.png";
import javaScript from "../assets/img/js1.png";
// import php from "../assets/img/php1.png";
import css from "../assets/img/css.png";
// import codeIgniter4 from "../assets/img/ci.png";
import tailWind from "../assets/img/buntutangin.png";
// import laravel8 from "../assets/img/laravell.png";
// import bootStrap from "../assets/img/boostrap.png";
import github from "../assets/img/github.png"
import angular from "../assets/img/angular.png"
import reactjs from "../assets/img/reactjs.png"
import dbeaver from "../assets/img/dbeaver.png"

const Skill = () => {
  return (
    <div className="lg:pl-10 px-10 py-8">
      <div className="lg:relative lg:overflow-y-auto lg:scrollbar-hide lg:max-h-[700px] pb-20 md:pb-32 lg:pb-44">
        <h1 className="text-2xl font-bold pt-5 text-center text-gradient-primary">SOFTAWARE</h1>
        <div className="w-16 h-1 bg-gradient-accent rounded-full mx-auto mt-2 mb-6"></div>
        <div className="grid grid-cols-2 justify-items-center md:flex md:flex-row lg:flex-wrap items-center md:justify-between lg:w-4/5 lg:mx-auto scrollbar-hide gap-4">
          <div className="pt-10 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in">
            <img src={msOffice} alt="MS Office" className="drop-shadow-md" />
            <p className="pt-3 text-sm font-medium text-slate-700">MS. Office</p>
          </div>
          <div className="pt-10 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in animation-delay-100">
            <img src={vsCode} alt="VS Code" className="drop-shadow-md" />
            <p className="pt-3 text-sm font-medium text-slate-700">VSCODE</p>
          </div>
          <div className="py-28 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in animation-delay-200">
            <img src={github} alt="GitHub Desktop" className="drop-shadow-md" />
            <p className="pt-3 text-sm font-medium text-slate-700">Github Desktop</p>
          </div>
          <div className="py-28 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in animation-delay-300">
            <img src={dbeaver} alt="DBeaver" className="drop-shadow-md" />
            <p className="pt-3 text-sm font-medium text-slate-700">DBeaver</p>
          </div>
        </div>

        <div className="py-20">
          <h1 className="text-2xl font-bold pt-5 text-center text-gradient-primary">
            BAHASA PEMROGRAMAN
          </h1>
          <div className="w-16 h-1 bg-gradient-accent rounded-full mx-auto mt-2 mb-6"></div>
          <div className="grid grid-cols-2 justify-items-center md:flex md:flex-row lg:flex-wrap items-center md:justify-between lg:w-4/5 lg:mx-auto scrollbar-hide gap-4">
            <div className="pt-10 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in">
              <img src={html} alt="HTML5" className="drop-shadow-md" />
              <p className="pt-3 text-sm font-medium text-slate-700">HTML5</p>
            </div>
            <div className="py-10 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in animation-delay-100">
              <img src={javaScript} alt="JavaScript" className="drop-shadow-md" />
              <p className="pt-3 text-sm font-medium text-slate-700">JavaScript</p>
            </div>
            <div className="py-28 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in animation-delay-200">
              <img src={css} alt="CSS" className="drop-shadow-md" />
              <p className="pt-3 text-sm font-medium text-slate-700">CSS</p>
            </div>
          </div>
        </div>

        <div className="pb-20">
          <h1 className="text-2xl font-bold pt-5 text-center text-gradient-primary">
            FRAMEWORK
          </h1>
          <div className="w-16 h-1 bg-gradient-accent rounded-full mx-auto mt-2 mb-6"></div>
          <div className="grid grid-cols-2 justify-items-center md:flex md:flex-row lg:flex-wrap items-center md:justify-between lg:w-4/5 lg:mx-auto scrollbar-hide gap-4">
            <div className="py-10 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in">
              <img src={reactjs} alt="ReactJS" className="drop-shadow-md" />
              <p className="pt-3 text-sm font-medium text-slate-700">ReactJS</p>
            </div>
            <div className="py-10 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in animation-delay-100">
              <img src={tailWind} alt="TailwindCSS" className="drop-shadow-md" />
              <p className="pt-3 text-sm font-medium text-slate-700">TailwindCSS</p>
            </div>
            <div className="py-28 md:pt-0 h-24 w-24 text-center transform transition-all duration-300 hover:scale-110 animate-fade-in animation-delay-200">
              <img src={angular} alt="Angular" className="drop-shadow-md" />
              <p className="pt-3 text-sm font-medium text-slate-700">AngularJS</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skill; 